import { render, staticRenderFns } from "./WechatConfigModal.vue?vue&type=template&id=36f26e85&scoped=true"
import script from "./WechatConfigModal.vue?vue&type=script&lang=js"
export * from "./WechatConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f26e85",
  null
  
)

export default component.exports